import styled from "styled-components"
import { 
    // COLOR,
    // FONT
 } from 'assets'
 
export const InputPaymentStyled = styled.div`
/*===============================================
 Container 
===============================================*/
    
/*===============================================
Theme 
===============================================*/
    .theme_standard {
        
    }
`